import Mobimages from "@frameworks/web/assets/images/MobHeader/ipo-img.png";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
const IpoCardBlock = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 mobile-offering-data  d-flex" },
            React.createElement(Col, { lg: 12, className: "px-0" },
                React.createElement(Link, { to: "/pricing" },
                    React.createElement("div", { className: "offering-viewplans  d-flex" },
                        React.createElement("img", { src: Mobimages }),
                        React.createElement("div", { className: "offering-viewplans-text" },
                            React.createElement("span", { className: "offtext" }, "Pricing starts at"),
                            React.createElement("div", { className: "orderamount" }, "\u20B910 per Order"),
                            React.createElement("span", { className: "offtext" },
                                " ",
                                "for Equity Delivery and Intraday"),
                            React.createElement("div", { className: "viewplans-icon" },
                                React.createElement("div", { className: "offtext" }, "View Plans"),
                                React.createElement("span", { className: "edel-icon-arrow-right" })))))))));
};
export default IpoCardBlock;
